module.exports = __webpack_public_path__ + "img/dp-sy-bm11.6e73476b.png";